export default "__VITE_ASSET__Xpc7AI54__"